import KValidatableInput from "./KValidatableInput";
import { VBtn, VBtnToggle, VCol, VRow } from "vuetify/lib";

export default {
	name: "KBooleanToggle",

	extends: KValidatableInput,

	props: {
		falseColor: {
			default: "error",
			type: String
		},
		falseLabel: {
			default: "No",
			type: String
		},
		mandatory: Boolean,
		trueColor: {
			default: "success",
			type: String
		},
		trueLabel: {
			default: "Yes",
			type: String
		},
		value: {
			default: null,
			type: Boolean
		}
	},

	computed: {
		internalValue: {
			get() {
				if ( this.mandatory ) {
					return Boolean( this.value );
				}

				return this.value;
			},

			set( val ) {
				this.$emit( "input", val );
			}
		},

		errorClasses() {
			return {
				"error--text": this.hasError && this.internalValue === null
			};
		},

		isTrue() {
			return this.internalValue === true;
		},

		isFalse() {
			if ( this.mandatory ) {
				return !this.internalValue;
			}


			return this.internalValue === false;
		}
	},

	methods: {
		onTrueClick() {
			if ( this.isTrue && !this.mandatory ) {
				this.internalValue = null;
			} else {
				this.internalValue = true;
			}
		},

		onFalseClick() {
			if ( this.isFalse && !this.mandatory ) {
				this.internalValue = null;
			} else {
				this.internalValue = false;
			}
		},

		genValidatableField() {
			return <VBtnToggle
				class="mr-2"
				mandatory={this.mandatory}
				vModel={this.internalValue}
			>
				<VBtn
					class={{
						"white--text": this.isTrue,
						...this.errorClasses
					}}
					color={this.isTrue ? this.trueColor : null}
					depressed={this.isTrue}
					onClick={this.onTrueClick}
					ripple={!this.isTrue}
					text={!this.isTrue}
					value={true}
				>
					{this.trueLabel}
				</VBtn>

				<VBtn
					class={{
						"white--text": this.isFalse,
						...this.errorClasses
					}}
					color={this.isFalse ? this.falseColor : null}
					depressed={this.isFalse}
					onClick={this.onFalseClick}
					ripple={!this.isFalse}
					text={!this.isFalse}
					value={false}
				>
					{this.falseLabel}
				</VBtn>
			</VBtnToggle>;
		},

		genDefaultSlot() {
			return <VRow align="center">
				<VCol class="pr-0 shrink">{this.genValidationProvider()}</VCol>
				<VCol class="pl-0">{this.genLabel()}</VCol>
			</VRow>;
		}
	}
};
